"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connector = exports.RegistrationState = void 0;

var events_1 = require("events");

var logger_1 = require("./logger");

var RegistrationState = /*#__PURE__*/function () {
  function RegistrationState() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var notificationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var messageTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();

    _classCallCheck(this, RegistrationState);

    this.token = token;
    this.notificationId = notificationId;
    this.messageTypes = messageTypes;
  }

  _createClass(RegistrationState, [{
    key: "clone",
    value: function clone() {
      return new RegistrationState(this.token, this.notificationId, new Set(this.messageTypes));
    }
  }]);

  return RegistrationState;
}();

exports.RegistrationState = RegistrationState;

function setDifference(a, b) {
  return [].concat(_toConsumableArray(_toConsumableArray(a).filter(function (x) {
    return !b.has(x);
  })), _toConsumableArray(_toConsumableArray(b).filter(function (x) {
    return !a.has(x);
  })));
}

function hasDifference(a, b) {
  var reasons = new Set();

  if (a.notificationId !== b.notificationId) {
    reasons.add('notificationId');
  }

  if (a.token !== b.token) {
    reasons.add('token');
  }

  if (setDifference(a.messageTypes, b.messageTypes).length > 0) {
    reasons.add('messageType');
  }

  return [reasons.size > 0, reasons];
}

var Connector = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(Connector, _events_1$EventEmitte);

  var _super = _createSuper(Connector);

  function Connector(config) {
    var _this;

    _classCallCheck(this, Connector);

    _this = _super.call(this);
    _this.config = config;
    _this.desiredState = new RegistrationState();
    _this.currentState = new RegistrationState();
    _this.hasActiveAttempt = false;
    return _this;
  }

  _createClass(Connector, [{
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(messageType) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.desiredState.messageTypes.has(messageType)) {
                  _context.next = 3;
                  break;
                }

                logger_1.log.debug('message type already registered ', messageType);
                return _context.abrupt("return");

              case 3:
                this.desiredState.messageTypes.add(messageType);
                _context.next = 6;
                return this.persistRegistration();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function subscribe(_x) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(messageType) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.desiredState.messageTypes.has(messageType)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.desiredState.messageTypes.delete(messageType);
                _context2.next = 5;
                return this.persistRegistration();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unsubscribe(_x2) {
        return _unsubscribe.apply(this, arguments);
      }

      return unsubscribe;
    }()
  }, {
    key: "updateToken",
    value: function updateToken(token) {
      this.desiredState.token = token;
      this.persistRegistration();
    }
  }, {
    key: "persistRegistration",
    value: function () {
      var _persistRegistration = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this2 = this;

        var _hasDifference, _hasDifference2, needToUpdate, reasons, stateToPersist, persistedState;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.config.token || this.config.token.length === 0)) {
                  _context3.next = 3;
                  break;
                }

                logger_1.log.trace('Can\'t persist registration: token is not set');
                return _context3.abrupt("return");

              case 3:
                if (!this.hasActiveAttempt) {
                  _context3.next = 6;
                  break;
                }

                logger_1.log.trace('One registration attempt is already in progress');
                return _context3.abrupt("return");

              case 6:
                _hasDifference = hasDifference(this.desiredState, this.currentState), _hasDifference2 = _slicedToArray(_hasDifference, 2), needToUpdate = _hasDifference2[0], reasons = _hasDifference2[1];

                if (needToUpdate) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return");

              case 9:
                if (!this.currentState.notificationId) {
                  reasons.delete('notificationId');
                }

                logger_1.log.trace('Persisting registration', reasons, this.desiredState);
                _context3.prev = 11;
                this.hasActiveAttempt = true;
                stateToPersist = this.desiredState.clone();

                if (!(stateToPersist.messageTypes.size > 0)) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 17;
                return this.updateRegistration(stateToPersist, reasons);

              case 17:
                persistedState = _context3.sent;
                this.currentState.token = persistedState.token;
                this.currentState.notificationId = persistedState.notificationId;
                this.currentState.messageTypes = persistedState.messageTypes;
                this.emit('stateChanged', 'registered');
                _context3.next = 30;
                break;

              case 24:
                _context3.next = 26;
                return this.removeRegistration();

              case 26:
                this.currentState.token = stateToPersist.token;
                this.currentState.notificationId = stateToPersist.notificationId;
                this.currentState.messageTypes.clear();
                this.emit('stateChanged', 'unregistered');

              case 30:
                _context3.prev = 30;
                this.hasActiveAttempt = false;
                setTimeout(function () {
                  return _this2.persistRegistration();
                }, 0);
                return _context3.finish(30);

              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[11,, 30, 34]]);
      }));

      function persistRegistration() {
        return _persistRegistration.apply(this, arguments);
      }

      return persistRegistration;
    }()
  }, {
    key: "setNotificationId",
    value: function setNotificationId(notificationId) {
      this.desiredState.notificationId = notificationId;
      this.persistRegistration();
    }
  }]);

  return Connector;
}(events_1.EventEmitter);

exports.Connector = Connector;